import React from "react";
import { Button } from "antd";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { observer } from "mobx-react-lite";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface OptionButtonProps {
    isShowMoreOptions: boolean;

    tab: OrderTab;
}

const OptionButton: React.FC<OptionButtonProps> = ({ isShowMoreOptions, tab }) => {
    const orderManagementStore = useOrderManagementStore();

    if ([OrderTab.LOGISTICS_WARNING, OrderTab.PICKUP_DEADLINE_WARNING].includes(tab)) return null;

    return (
        <Button
            onClick={() => {
                orderManagementStore.table.toggleMoreSearchOptions();
            }}
            size="small"
            className="mr10"
        >
            {isShowMoreOptions ? "常用选项 ↑" : "更多选项 ↓"}
        </Button>
    );
};

export default observer(OptionButton);
